module.exports = __webpack_public_path__ + "img/review_banner_m.c3afbbf.svg";